export default __webpack_public_path__ + "static/media/forest_header_mobile.2dfab08d.png";